import React from 'react';
import { useTranslation } from 'react-i18next';
import { DEPRECATED_ConfigurationApp } from 'smartsuite-configuration-app';
import { uriConstants } from '../../constants/ConfigurationConstants';
import useFavorite from '../../../../hooks/useFavorite';
import getCurrentLanguage from '../../../../utils/getCurrentLanguage';
import {
    buildEnterpriseAndSortChanges,
    buildStateFromApiCall,
} from './utils/KpiConfigUtils';
import pageConfiguration from './pageLayoutConfiguration';

const SYSTEM_KEY = 'ENTERPRISE';

export default function AppWrapper() {
    const { i18n } = useTranslation('configuration');
    const favoriteUtilities = useFavorite();
    const resourceData = i18n.getDataByLanguage(getCurrentLanguage());

    return (
        <DEPRECATED_ConfigurationApp
            apiEndpoint={uriConstants.kpiConfigurationUri}
            labels={{ configurationLabels: resourceData.configuration }}
            dataMappers={{
                buildChangesToSave: buildEnterpriseAndSortChanges(SYSTEM_KEY),
                buildStateFromApiCall,
            }}
            favoriteUtilities={favoriteUtilities}
            pageConfiguration={pageConfiguration}
            uriConstants={uriConstants}
        />
    );
}
